<template lang="pug">
  v-card.student-photo(outlined style="border: none;")
    .image-rect.d-flex.justify-center(v-if="!cropping")
      img(
        v-if="imageSrc"
        :src="imageSrc"
        :aspect-ratio="0.707"
        :contain="true"
      )

      img(
        v-else
        src=""
        :aspect-ratio="0.707"
        :contain="true"
      )

    .cropper-wrapper(v-if="cropping")
      vue-cropper#vue-croper(
        ref="cropper"
        v-bind="cropperOptions"
      )

    v-card-actions.py-4
      v-row(v-if="imageError")
        v-col.red--text(cols="12") {{ imageError }}

      v-row.justify-between.mt-1(v-else)
        v-col.text-center.upload-icons-primary(cols="6" style="padding: 0 12px 0 4px; min-height:40px;")
          //- a.d-inline-block.mx-auto(v-if="cropping" @click="onCropImage")
          //-   v-icon(color="primary") done
          //- v-btn.btn-done(v-if="cropping" depressed color="secondary" small @click="onCropImage")
          //-   v-icon(color="primary") done
          v-btn(v-if="cropping" depressed @click="onCropImage" style="background-color: #024589; color: #fff; min-height:40px;")
            span Logo Speichern

          //- a.d-flex.justify-center.align-center(v-else-if="!hideSelect" :class="disabled && 'disabled'" @click="$refs.file.click()")
          //-   span Bild hochladen
          //-   img(:src="getAssetImage('icon_upload.svg')" style="width: 30px;")
          v-btn(v-else-if="!hideSelect" depressed :class="disabled && 'disabled'" style="background-color: #024589; color: #fff; min-height:40px;" @click="$refs.file.click()")
            //- v-icon(style="margin-right: 5px;") file_upload
            svg.mr-2(xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" version="1.1" x="0px" y="0px" viewBox="0 0 64 64" enable-background="new 0 0 64 64" xml:space="preserve")
              g(id="Ebene_2")
              g(id="Ebene_1")
                path(id="Icon_final" fill="#fff" d="M22.204,15.456l-2.828-2.83L32,0l12.626,12.626l-2.83,2.83L34,7.656v45.862h-4V7.656   L22.204,15.456z M59.982,48.016v9.912C59.979,59.073,59.049,60,57.903,60H6.097c-1.146,0-2.076-0.927-2.079-2.072v-9.912H0v9.912   C0.011,61.287,2.738,64.003,6.097,64h51.806c3.359,0.003,6.086-2.713,6.097-6.072v-9.912H59.982z")
            span Logo Upload

        v-col.position-relative.text-center.upload-icons-red(cols="6" style="padding: 0 4px 0 12px;  ")

          //- a.d-inline-block.mx-auto(v-if="cropping" @click="onResetImage")
          //-   v-icon(color="red") close
          //- v-btn(v-if="cropping" depressed color="error" small @click="onResetImage")
          //-   v-icon(color="white") close
          v-btn(v-if="cropping" depressed @click="onResetImage" style="background-color: #d90000; color: #fff; min-height:40px;")
            //- v-icon(style="margin-right: 5px;") delete
            svg.mr-2(xmlns="http://www.w3.org/2000/svg" version="1.1" width="20" height="20" viewBox="0 0 32 32")
              title papierkorb
              path(fill="#fff" d="M4 8.001l0.004 0.59 1.928 21.563c0.086 1.035 0.945 1.843 1.994 1.847h16.149c1.045-0.003 1.902-0.805 1.993-1.827l0.001-0.008 1.933-21.664v-0.502h-2l0.004 0.413-1.93 21.587-16.149-0.012-1.925-21.486v-0.502zM19.416 0h-6.829l-1.586 1.586v2.414h-8.001v2h26v-2h-7.999v-2.414zM13.001 2.414l0.414-0.414h5.172l0.414 0.415v1.585h-6z")
            span Logo Iöschen

          //- a.upload-icons.d-flex.justify-center.align-center(v-else :class="(!imageSrc || disabled) && 'disabled'" @click="onResetImage" style="backgound-color: ")
          //-   span Bild entfernen
          //-   img(:src="getAssetImage('icon_delete.svg')" style="width: 30px;")
          v-btn(v-else-if="imageSrc" depressed :class="(!imageSrc || disabled) && 'disabled'" @click="onResetImage" style="background-color: #d90000; color: #fff; min-height:40px;")
            //- v-icon(style="margin-right: 5px;") delete
            svg.mr-2(xmlns="http://www.w3.org/2000/svg" version="1.1" width="20" height="20" viewBox="0 0 32 32")
              title papierkorb
              path(fill="#fff" d="M4 8.001l0.004 0.59 1.928 21.563c0.086 1.035 0.945 1.843 1.994 1.847h16.149c1.045-0.003 1.902-0.805 1.993-1.827l0.001-0.008 1.933-21.664v-0.502h-2l0.004 0.413-1.93 21.587-16.149-0.012-1.925-21.486v-0.502zM19.416 0h-6.829l-1.586 1.586v2.414h-8.001v2h26v-2h-7.999v-2.414zM13.001 2.414l0.414-0.414h5.172l0.414 0.415v1.585h-6z")
            span Logo Iöschen

    input.d-none(
      ref="file"
      class="d-none"
      type="file"
      accept="image/*"
      @change="onSelectFile"
    )

</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'
import FormMixin from '@/mixins/form'
import Urls from '@/router/urls'
import 'cropperjs/dist/cropper.css'

const IMAGE_WIDTH = 800
const IMAGE_HEIGHT = 600

@Component({
  mixins: [
    FormMixin
  ],

  components: {
    VueCropper: () => import('vue-cropperjs')
  },

  watch: {
    file () {
      if (this.file && typeof this.file === 'string') {
        this.imageSrc = this.file
      } else if (!this.file) {
        this.imageSrc = null
      }
    }
  }
})
export default class CompanyLogo extends Vue {
  @Prop({
    type: [Blob, String],
    default: null
  }) file

  @Prop({
    type: Boolean,
    default: false
  }) disabled

  @Prop({
    type: Boolean,
    default: false
  }) hideSelect

  @Prop({
    type: Number | String,
    default: null
  }) companyId

  imageSrc = null
  imageName = null
  cropping = false
  imageError = null

  cropperOptions = {
    aspectRatio: IMAGE_WIDTH / IMAGE_HEIGHT,
    minCropBoxHeight: 1,
    zoomOnWheel: false,
    guides: false,
    viewMode: 1
  }

  mounted () {
    if (this.file) {
      this.imageSrc = this.file
    }
  }

  submitImage (blob) {
    const params = new FormData()

    params.append('logo', blob, this.imageName)
    this.$axios
      .post(Urls.CompanyLogo(this.companyId), params, true)
      .then(() => {
        this.$emit('select', blob)
      })
      .catch(err => {
        this.imageError = err.message
        this.$emit('reset')
      })
  }

  onSelectFile (e) {
    if (!e.target.files || !e.target.files[0]) {
      return
    }

    this.imageError = null
    this.imageSrc = URL.createObjectURL(e.target.files[0])
    this.imageName = e.target.files[0].name
    this.cropping = true

    setTimeout(() => {
      this.$refs.cropper.reset()
      this.$refs.cropper.replace(this.imageSrc)
    }, 300)
  }

  onCropImage () {
    const cropper = this.$refs.cropper
    const canvas = cropper.getCroppedCanvas({
      width: IMAGE_WIDTH,
      height: IMAGE_HEIGHT,
      fillColor: '#ffffff',
    })

    this.$refs.file.value = null
    this.imageSrc = canvas.toDataURL()
    this.cropping = false
    // for IE
    if (canvas.msToBlob) {
      const blob = canvas.msToBlob()
      if (blob) {
        console.log(this.companyId)
        if (this.companyId !== 0) {
          this.submitImage(blob)
        } else {
          this.$emit('uploadOnCreation', blob, this.imageName)
        }
        return
      }
    }

    // for other browsers
    canvas.toBlob((blob) => {
      if (this.companyId !== 0) {
        this.submitImage(blob)
      } else {
        this.$emit('uploadOnCreation', blob, this.imageName)
      }
    })
  }

  getAssetImage (name) {
    return require(`@/assets/images/${ name }`)
  }

  onResetImage () {
    this.cropping = false
    this.imageSrc = null
    this.imageError = null
    this.$refs.file.value = null
    this.$emit('reset')
  }
}
</script>

<style lang="sass">
.student-photo
  width: 100%

  .v-card__actions
    a
      color: #fff
      line-height: 1.25

      &.disabled
        color: #ccc
        pointer-events: none

        .v-icon
          color: inherit

    .v-btn
      width: 100%

    .hr-left
      top: 50%
      left: 0
      color: #999
      font-size: 30px
      transform: translateY(-50%)

  .cropper-wrapper
    display: flex
    align-items: center
    background-color: #000
    width: 100%
    height: 350px

    #vue-croper
      width: 100%
      height: 350px

      .cropper-container
        margin: auto

      .cropper-bg
        background-image: none

  .image-rect
    background-color: #ebf1fb
    width: 100%
    height: 350px

    img
      max-width: 100%
      max-height: 100%

    .v-image
      box-shadow: none

  @media screen and (max-width: 1920px)
    .cropper-wrapper
      height: 15vw

      #vue-croper
        height: 15vw

    .image-rect
      height: 15vw

  @media screen and (max-width: 960px)
    .cropper-wrapper
      height: 30vw

      #vue-croper
        height: 30vw

    .image-rect
      height: 30vw
</style>
